import { API } from './api';

export const GetTicketsList = (params: any) =>
  API.get('/cabinet/tickets/', params);

export const CreateTicket = (data: any) => API.post('/cabinet/tickets/', data);

export const UpdateTicketFiles = (id: string, params: FormData) =>
  API.patchFiles('/cabinet/tickets/files/', id, params);
